import $ from 'jquery'
/**
 * Tool UI class
 * @param {Object} config
 * @constructor
 */
export default class Tool {
  constructor(config) {
    $.extend(this, config || {})

    this.el = $('<span class="olga.tool">')

    this.iconClass = 'map-measure-area'
  }

  activate() {
    $('#navbarSouth .dropdown-toggle')
      .find('i')
      .removeClass()
      .addClass(this.iconClass)
  }

  deactivate() {
    $('#navbarSouth .dropdown-toggle')
      .find('i')
      .removeClass()
      .addClass('map-navigate')
  }
}
